import React, { FormEvent, useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges, ReactFlowInstance} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-sample-data-node-configuration";
import { ModelSchemaWidget } from "./components/ModelSchemaWidget";
import {
    Button
} from '@mui/material';

export const WorkflowSampleDataNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleShowSampleDataModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'data_to_loop',
                    'latest_user_message',
                    'scraper_pending'
                ]
            }
        },
        'custom_error_message': {
            'ui:widget': 'textarea'
        },
        'sample_data_model': {
            'ui:widget': 'ModelSchemaWidget'
        },
        'sample_data_model_value': {
            'ui:widget': 'textarea'
        },
        'sample_key_value_array': {
            'ui:widget': 'textarea'
        },
        'ui:order': [
            'sample_type',
            'allOf',
            'sample_text',
            'sample_number',
            'sample_true_false',
            'sample_data_model',
            'sample_data_model_value',
            'sample_array',
            'sample_key_value_array',
            'data_management'
        ],
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget,
        ModelSchemaWidget: ModelSchemaWidget
    }

    useEffect( () => {
        if (context.activeSampleDataNode !== undefined && context.activeSampleDataNode.data !== undefined) {
            setFormData(context.activeSampleDataNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showSampleDataModal }
            title={ "Sample Data Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeSampleDataNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>


                </div>
            </Form>
        </DefaultFormDialog>
    );

}